import React from "react";
import { Tabs } from "antd";

const SbTabs = ({
  activeKey,
  onChange,
  items,
  size,
  tabBarExtraContent,
  ...rest
}) => {
  return (
    <Tabs
      size={size}
      activeKey={activeKey}
      onChange={onChange}
      tabBarExtraContent={tabBarExtraContent}
      items={items}
      {...rest}
    />
  );
};

export default SbTabs;